

export default {
  data() {
    return {
      currentTab: {},
    };
  },
  components: {

    Characteristics: () => import('~/components/product/product-info/Characteristics'),
    VForm: () => import('~/components/VForm/VForm'),
    DeliveryInfo: () => import('~/components/product/ProductDeliveryInfo.vue'),
  },
  props: {
    characteristics: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      default: '',
    },
  },

  computed: {
    tabs() {
      return [
        {
          id: 4, name: 'delivery', title: 'Доставка и оплата', isShow: true,
        },
        {
          id: 1, name: 'descriptions', title: 'Описание', isShow: Boolean(this.description),
        },
        {
          id: 2,
          name: 'characteristics',
          title: 'Характеристики',
          isShow: this.characteristics?.[0]?.characteristics.length > 1,
        },

        {
          id: 3, name: 'feedback', title: 'Задать вопрос', isShow: true,
        },
      ];
    },
  },

  methods: {
    changeTab(tab) {
      this.currentTab = tab;
    },
  },

  mounted() {
    this.changeTab(this.tabs.find((t) => t.name === 'delivery'));
  },
};
